import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import Order from "./Order";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {Col, Form, FormFeedback, Row, Input, Label, Button} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getOrders} from "../../api/api";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";
import {useLocation, useNavigate} from "react-router-dom";

function OrderPage() {
    // const queryClient = useQueryClient()
    const {refreshToken} = useContext(AuthContext)
    const location = useLocation();
    const orderIdFromState = location.state?.orderId || '';

    const [page, setPage] = useState(1);
    const [orderId, setOrderId] = useState("");
    const [orderNumber, setOrderNumber] = useState(orderIdFromState);
    const [orderCustomerName, setOrderCustomerName] = useState("");
    const [orderTotalAmount, setOrderTotalAmount] = useState("");
    const [orderStatus, setOrderStatus] = useState("");
    const [orderPaymentMethod, setOrderPaymentMethod] = useState("");
    const [orderPaymentStatus, setOrderPaymentStatus] = useState("");

    const [queryKey, setQueryKey] = useState(['orders', page])
    const navigate = useNavigate()

    useEffect(() => {
        setQueryKey(['orders', page])
    }, [page]);

    useEffect(() => {
        if (
            orderId === '' && orderNumber === '' && orderCustomerName === '' && orderTotalAmount === '' && orderStatus === ''
            && orderPaymentMethod === '' && orderPaymentStatus === '') {
            clearSearchOrder();
        }
    }, [
        orderId, orderNumber, orderCustomerName, orderTotalAmount, orderStatus, orderPaymentMethod, orderPaymentStatus]);


    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getOrders(page, orderId, orderNumber, orderCustomerName, orderTotalAmount,
            orderStatus, orderPaymentMethod, orderPaymentStatus),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
            if(err.response.status === 403){
                navigate(-1)
            }
        })
        })

    const searchOrder = (e) =>{
        e.preventDefault()
        setPage(1)
        setQueryKey( ['orders', page, orderId, orderNumber, orderCustomerName, orderTotalAmount, orderStatus,
            orderPaymentMethod, orderPaymentStatus])
    }

    const clearSearchOrder = (e) =>{
        e?.preventDefault()
        setOrderId('')
        setOrderNumber('')
        setOrderCustomerName('')
        setOrderTotalAmount('')
        setOrderStatus('')
        setOrderPaymentMethod('')
        setOrderPaymentStatus('')
        setQueryKey( ['orders', 1])
        // setPage(1)
    }

    return (
        <>
            <div className="card-box">
                <div className="row">
                    <div className="col-sm-12">

                        <Form onSubmit={searchOrder}>
                            <Row className="form-row align-items-center">
                                {/*<Col>*/}
                                {/*    <Label*/}
                                {/*        className="visually-hidden"*/}
                                {/*        for="order-id"*/}
                                {/*    >*/}
                                {/*        ID*/}
                                {/*    </Label>*/}
                                {/*    <Input*/}
                                {/*        id="order-id"*/}
                                {/*        name="order-id"*/}
                                {/*        type="text"*/}
                                {/*        className="form-control mb-2"*/}
                                {/*        onChange={(e) =>*/}
                                {/*            setOrderId(*/}
                                {/*                e.target.value*/}
                                {/*            )*/}
                                {/*        }*/}
                                {/*        value={orderId}*/}
                                {/*        invalid={*/}
                                {/*            error && error.response.data.id*/}
                                {/*        }*/}
                                {/*    />*/}
                                {/*    <FormFeedback invalid>*/}
                                {/*        {error && error.response.data.id}*/}
                                {/*    </FormFeedback>*/}
                                {/*</Col>*/}
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="order-number"
                                    >
                                        Order Number
                                    </Label>
                                    <Input
                                        id="order-number"
                                        name="order-number"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setOrderNumber(
                                                e.target.value
                                            )
                                        }
                                        value={orderNumber}
                                        invalid={
                                            error && error.response.data.order_number
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.order_number}
                                    </FormFeedback>
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="customer-name"
                                    >
                                        Customer Name
                                    </Label>
                                    <Input
                                        id="customer-name"
                                        name="customer-name"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setOrderCustomerName(
                                                e.target.value
                                            )
                                        }
                                        value={orderCustomerName}
                                        invalid={
                                            error && error.response.data.customer
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.customer}
                                    </FormFeedback>
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="total-amount"
                                    >
                                        Order Total
                                    </Label>
                                    <Input
                                        id="total-amount"
                                        name="total-amount"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setOrderTotalAmount(
                                                e.target.value
                                            )
                                        }
                                        value={orderTotalAmount}
                                        invalid={
                                            error && error.response.data.total_amount
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.total_amount}
                                    </FormFeedback>
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="order-status"
                                    >
                                        Order Status
                                    </Label>
                                    <Input
                                        type="select"
                                        id="inputState"
                                        className="form-control mb-2"
                                        value={orderStatus}
                                        onChange={(e) =>
                                            setOrderStatus(
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">--</option>
                                        <option value={"PENDING"}>
                                            Pending
                                        </option>
                                        <option value={"BEING-PROCESSED"}>
                                            Being Processed
                                        </option>
                                        <option value={"IN-TRANSIT"}>
                                            In Transit
                                        </option>
                                        <option value={"COMPLETE"}>
                                            Complete
                                        </option>
                                        <option value={"CANCELLED"}>
                                            Cancelled
                                        </option>
                                    </Input>
                                    {/*<FormFeedback invalid>*/}
                                    {/*    {error && error.response.data.description}*/}
                                    {/*</FormFeedback>*/}
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="payment-status"
                                    >
                                        Payment Status
                                    </Label>
                                    <Input
                                        type="select"
                                        id="inputState"
                                        className="form-control mb-2"
                                        value={orderPaymentStatus}
                                        onChange={(e) =>
                                            setOrderPaymentStatus(
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">--</option>
                                        <option value={"UNPAID"}>
                                            Unpaid
                                        </option>
                                        <option value={"PAID"}>
                                            Paid
                                        </option>
                                        <option value={"WAIVED-OFF"}>
                                            Waived Off
                                        </option>
                                    </Input>
                                    {/*<FormFeedback invalid>*/}
                                    {/*    {error && error.response.data.description}*/}
                                    {/*</FormFeedback>*/}
                                </Col>

                            </Row>
                            <Row className="form-row align-items-center">
                                <Col>
                                    <Button type="submit"
                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                            disabled={!orderId && !orderNumber && !orderCustomerName &&
                                                !orderTotalAmount && !orderStatus && !orderPaymentMethod &&
                                                !orderPaymentStatus}
                                    >
                                        Search
                                    </Button>

                                    <Button type="button"
                                            onClick={clearSearchOrder}
                                            className="btn bx-btn-primary waves-effect waves-light"
                                            disabled={!orderId && !orderNumber && !orderCustomerName &&
                                                !orderTotalAmount && !orderStatus && !orderPaymentMethod &&
                                                !orderPaymentStatus}
                                    >
                                        Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>

            {status === 'loading' && (
                <Loader size={'default'}/>
            )}

            {/*{status === 'error' && (*/}
            {/*    <p>Error...{error.response.status}</p>*/}
            {/*)}*/}

            {status === 'success' | error?.response?.status === 401 && (
                <div className="row">
                    <div className="col-12">



                        <div className="card-box">
                            <div className="table-responsive">
                                <table className="table table-centered mb-0">
                                    <thead className="font-13 bg-light text-muted">
                                    <tr>
                                        <th className="font-weight-medium">Order ID</th>
                                        <th className="font-weight-medium">Customer</th>
                                        <th className="font-weight-medium">Order Total</th>
                                        <th className="font-weight-medium">Order Source</th>
                                        <th className="font-weight-medium">Short Order URL</th>
                                        <th className="font-weight-medium">Order Status</th>
                                        <th className="font-weight-medium">Payment Method</th>
                                        <th className="font-weight-medium">Payment Status</th>
                                        <th className="font-weight-medium">Created</th>
                                        <th className="font-weight-medium text-center">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data?.count > 0? data?.results?.map(order => (
                                        <Order key={order.id} order={order}/>
                                    )): <RecordsNotFound/>}
                                    </tbody>
                                </table>
                            </div>
                            {status === 'success' && (
                                <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default OrderPage;
